export function isLocal() {
  const url = new URL(window.location.href).origin
  return url.includes('localhost') || url.includes('127.0.0.1')
}

// Адрес возврата после входа и выхода через Cognito — всегда тот же хост, с которого пришёл
// пользователь. PKCE code_verifier лежит в storage конкретного origin: если вернуть человека на
// другой домен (начал вход на blizzard.mintohot.net, а redirect зашит на blizzard.btc4swc.com),
// обмен кода на токен провалится. Поэтому адрес не зашивается в сборку, а берётся из текущего
// origin, и одна сборка работает на любом из доменов. Каждый такой адрес должен быть в
// CallbackURLs клиента Cognito (клиент blizzard-bo-client, пул eu-north-1_yh0WAk9Ci).
export function authRedirectUrl() {
  return `${window.location.origin}/redirect`
}
